export default {
  apartments: {
    breadcrumbHome: 'Accueil',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Immeubles et biens immobiliers',
    hero: {
      eyebrow: 'Immeubles et biens immobiliers',
      title: 'La sécurité pour des immeubles entiers',
      lead: 'Entrée, cage d’escalier, garage souterrain : nous planifions une surveillance qui protège les locataires et rassure les propriétaires.',
    },
    areas: {
      title: 'Points de surveillance dans les immeubles',
      lead: 'Les parties communes sont les points de départ les plus importants. Nous respectons toujours les droits de tous les résidents.',
      items: {
        '0': { title: 'Entrée de l’immeuble', desc: "L'entrée est la vitrine du bâtiment et le point de surveillance le plus important. Les caméras captent qui entre." },
        '1': { title: "Cage d'escalier", desc: 'Les escaliers sont des passages très fréquentés. Des caméras compactes comblent discrètement les lacunes entre étages.' },
        '2': { title: 'Local à vélos', desc: 'Vélos et vélos électriques sont des cibles de vol courantes. La surveillance dissuade et aide à clarifier.' },
        '3': { title: 'Espaces extérieurs', desc: 'Aires de jeux, espaces verts et chemins sont communs. Des caméras résistantes protègent aussi ici.' },
        '4': { title: 'Garage souterrain', desc: 'Les places du garage souterrain sont exposées la nuit. Une surveillance bien éclairée crée la sécurité.' },
        '5': { title: 'Boîtes aux lettres', desc: 'Boîtes et casiers à colis sont le point clé du vol de colis. Les caméras d’accès aident nettement.' },
      },
    },
    protection: {
      eyebrow: 'Protection des données et règlement',
      title: 'Surveiller sans porter atteinte',
      lead: 'De nombreux intérêts se croisent dans un immeuble. Nous mettons en œuvre une surveillance qui respecte la vie privée et reste légale.',
      items: {
        '0': { title: 'Masquage des zones privées', desc: 'Fenêtres, portes et zones privées sont masquées techniquement ; seules les parties communes restent visibles.' },
        '1': { title: 'Délibération et règlement', desc: "La vidéosurveillance en immeuble exige une base solide. Nous vous aidons à la mettre en œuvre proprement." },
        '2': { title: 'Signalétique', desc: 'Des avis clairs à l’entrée informent locataires et visiteurs, de façon transparente et juste.' },
      },
    },
    value: {
      eyebrow: 'Valeur ajoutée',
      title: 'Avantages pour propriétaires et gestionnaires',
      lead: 'Un système bien pensé profite à tous : les locataires se sentent plus en sécurité, les propriétaires protègent leur bien et les gestionnaires gagnent en clarté.',
      list: {
        '0': 'Accès pour gestionnaires et propriétaires avec droits séparés',
        '1': 'Enregistrement des derniers jours ou semaines, selon la configuration',
        '2': 'Soulagement de la gestion en cas d’incident ou de litige',
        '3': 'Documentation complète en cas de vandalisme ou d’effraction',
        '4': 'Dissuasion des accès non autorisés',
        '5': 'Un sentiment de sécurité accru pour locataires et propriétaires',
      },
      note: 'Remarque : la licéité de la vidéosurveillance dans les immeubles dépend fortement du cas. Nous vous conseillons, sans remplacer le conseil juridique.',
    },
    cta: {
      title: 'Plus de sécurité pour votre immeuble',
      lead: 'Nous conseillons copropriétés et gestionnaires sans engagement, de l’idée au système clé en main.',
      primary: 'Prendre rendez-vous',
      secondary: 'Lancer le planificateur de caméras',
    },
  },
};